import { FC, SVGProps } from 'react';

export const ShareIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			d="M16.4881 4.43056C16.2072 4.18981 15.7928 4.18981 15.5119 4.43056L12.0119 7.43056C11.6974 7.70012 11.661 8.1736 11.9306 8.48809C12.2001 8.80259 12.6736 8.83901 12.9881 8.56944L15.25 6.63067V18C15.25 18.4142 15.5858 18.75 16 18.75C16.4142 18.75 16.75 18.4142 16.75 18V6.63067L19.0119 8.56944C19.3264 8.83901 19.7999 8.80259 20.0695 8.48809C20.339 8.1736 20.3026 7.70012 19.9881 7.43056L16.4881 4.43056Z"
			fill="currentColor"
		/>
		<path
			d="M5.75 18C5.75 15.6528 7.65279 13.75 10 13.75H11.5C11.9142 13.75 12.25 13.4142 12.25 13C12.25 12.5858 11.9142 12.25 11.5 12.25H10C6.82436 12.25 4.25 14.8244 4.25 18V22C4.25 25.1756 6.82436 27.75 10 27.75H22C25.1756 27.75 27.75 25.1756 27.75 22V18C27.75 14.8244 25.1756 12.25 22 12.25H20.5C20.0858 12.25 19.75 12.5858 19.75 13C19.75 13.4142 20.0858 13.75 20.5 13.75H22C24.3472 13.75 26.25 15.6528 26.25 18V22C26.25 24.3472 24.3472 26.25 22 26.25H10C7.65279 26.25 5.75 24.3472 5.75 22V18Z"
			fill="currentColor"
		/>
	</svg>
);
